import React, { FC } from "react";
import { Modal } from "@shared/components/Modal";
import { ButtonPrimary, ButtonSecondary } from "@shared/components";
import "./index.scss";
import { actions as PayPerLeadActions } from "@containers/PayPerLead/store";
import { useDispatch } from "react-redux";

interface ModalApplyCountyPriceProps {
  onClose: () => void;
  data?: {
    items: {
      countyId: number;
      price: number;
      limit: number;
    }[];
    fetchData: () => void;
  };
}

export const ModalApplyCountyPrice: FC<ModalApplyCountyPriceProps> = ({ onClose, data }) => {
  const dispatch = useDispatch();

  const apply = (immediately: boolean) => {
    dispatch(
      PayPerLeadActions.applyNewPrices.request({
        items: data?.items || [],
        immediately,
        callback: () => {
          data?.fetchData();
          onClose();
        },
      }),
    );
  };

  return (
    <div className="modal-apply-county-price">
      <Modal.Section>
        <Modal.Title>Apply these changes immediately?</Modal.Title>
        <Modal.Content>Would you like to apply new price immediately or at the end of the billing cycle?</Modal.Content>
        <Modal.Actions>
          <ButtonSecondary onClick={onClose}>Cancel</ButtonSecondary>
          <ButtonSecondary onClick={() => apply(true)}>Apply Now</ButtonSecondary>
          <ButtonPrimary type="submit" onClick={() => apply(false)}>
            Apply
          </ButtonPrimary>
        </Modal.Actions>
      </Modal.Section>
    </div>
  );
};
